<template>
    <bottom-sheet v-model="shows" title="미리보기" fullscreen persistent width="1200">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <recruitment-view-card v-bind="{ recruitment: { ...recruitment, company: $store.state.user } }" isPreview class="py-60" />
    </bottom-sheet>
</template>

<script>
import { initRecruitment } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import RecruitmentViewCard from "@/components/client/recruitments/view/recruitment-view-card.vue";

export default {
    components: {
        BottomSheet,
        RecruitmentViewCard,
    },
    props: {
        recruitment: { type: Object, default: initRecruitment },
    },
    data: () => ({
        shows: false,
    }),
};
</script>

<style>
</style>